import PropTypes from 'prop-types';
import React from 'react';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

const Tag = ({
    items = null,
    title = null,
    url   = null,
}) => {
    // render
    return (
        <a
            className='link-reset tag'
            href={url}>
            <span>{title}</span>
            <sup>{items?.total}</sup>
        </a>
    );
};

/* =========================================================================  */
/* Typing and export(s) */
/* =========================================================================  */

const propTypes = {
    items: PropTypes.object,
    title: PropTypes.string.isRequired,
    url  : PropTypes.string.isRequired,
};

Tag.propTypes = propTypes;

export { Tag };

export default Tag;
